/* unplugin-vue-components disabled */import script from "./separate-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./separate-upload.vue?vue&type=script&setup=true&lang=ts"

import "./separate-upload.vue?vue&type=style&index=0&id=08fd3fe1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fd3fe1"]])

export default __exports__